// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1iKIa","content":"Page_content__2l3YH","scrollingDisabled":"Page_scrollingDisabled__gt7u-"};